module.exports = __webpack_public_path__ + "img/logo-bizmob.a06a2be0.png";